require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tapd-in-influencer-marketing-101.json") })
        }
      }, "path---tapd-in-influencer-marketing-101");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tapd-in-influencer-marketing-101!./.cache/json/tapd-in-influencer-marketing-101.json
// module id = 855
// module chunks = 231608221292675